/* Scaled Haus — proof-strip count-up + chart draw-in.
   Final values are server-rendered; no-JS and reduced-motion users see them as-is. */
(function () {
  document.documentElement.classList.add('sh-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function fmt(n, d) {
    return n.toLocaleString('en-CA', { minimumFractionDigits: d, maximumFractionDigits: d });
  }

  // Count-up
  var strip = document.querySelector('[data-sh-proof]');
  if (strip && hasIO && !reduced) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          e.target.querySelectorAll('[data-sh-count]').forEach(function (el) {
            var target = parseFloat(el.getAttribute('data-value'));
            var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
            var duration = 1300;
            var start = null;
            function step(t) {
              if (start === null) start = t;
              var p = Math.min((t - start) / duration, 1);
              var eased = 1 - Math.pow(1 - p, 3);
              el.textContent = fmt(target * eased, decimals);
              if (p < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          });
        });
      },
      { threshold: 0.4 }
    );
    io.observe(strip);
  }

  // Chart draw-in
  document.querySelectorAll('[data-sh-chart]').forEach(function (fig) {
    if (!hasIO || reduced) {
      fig.classList.add('sh-in-view');
      return;
    }
    var cio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            fig.classList.add('sh-in-view');
            cio.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    cio.observe(fig);
  });
})();
